import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ADD_PRODUCT_PATH } from '@app/constants';

export const useProductDirectoryHeader = () => {
  const navigate = useNavigate();

  const goToAddProduct = useCallback(
    () => navigate(ADD_PRODUCT_PATH),
    [navigate]
  );

  return { goToAddProduct };
};
